import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import shortid from "shortid";
import getDiscounts from "../store/discounts/getAll/actions";

const useAllDiscounts = () => {
    const [formatedData, setFormatedData] = useState([]);

    const dispatch = useDispatch();
    const { loading, data, error } = useSelector((store) => store.getDiscounts);

    useEffect(() => {
        if (!data[0]) {
            dispatch(getDiscounts());
        }
    }, [dispatch]);

    useEffect(() => {
        setFormatedData(
            data.reduce((acc, ele) => {
                acc.push({
                    key: shortid.generate(),
                    ...ele,
                });
                return acc;
            }, [])
        );
    }, [data]);

    return [loading, formatedData, error];
};
export default useAllDiscounts;
